export default "__VITE_ASSET__CiU7YxX1__"